/**
 * Trigger: tr_exchanges_soft_delete_external
 * Purpose: When an exchange is soft-deleted, detach its related external marker links
 * Table: exchanges
 * Event: UPDATE OF is_deleted
 */
export const TR_EXCHANGES_SOFT_DELETE_EXTERNAL = `
CREATE TRIGGER tr_exchanges_soft_delete_external
UPDATE OF is_deleted ON exchanges
WHEN new.is_deleted <> 0 AND old.is_deleted = 0
BEGIN
  UPDATE external_transactions
  SET exchange_id = NULL
  WHERE exchange_id = old._id AND is_deleted = 0;
END;
`;
